import _styled from "@emotion/styled/base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

export var Image = /*#__PURE__*/_styled("img", true ? {
  target: "e16bywro0"
} : {
  target: "e16bywro0",
  label: "Image"
})(true ? {
  name: "fmbosm",
  styles: "display:block;height:auto;max-width:100%;margin:0 auto"
} : {
  name: "fmbosm",
  styles: "display:block;height:auto;max-width:100%;margin:0 auto",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvU2VjdGlvblRhYmJlZC9fX3N0b3JpZXNfXy9JbWFnZS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRStCIiwiZmlsZSI6Ii93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvU2VjdGlvblRhYmJlZC9fX3N0b3JpZXNfXy9JbWFnZS50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcblxuZXhwb3J0IGNvbnN0IEltYWdlID0gc3R5bGVkLmltZ2BcbiAgZGlzcGxheTogYmxvY2s7XG4gIGhlaWdodDogYXV0bztcbiAgbWF4LXdpZHRoOiAxMDAlO1xuICBtYXJnaW46IDAgYXV0bztcbmBcbmV4cG9ydCBkZWZhdWx0IEltYWdlXG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
export default Image;